import BaseClient from './BaseClient';

interface GetStatusLogParams {
    start_date?: string;
    end_date?: string;
    cursor?: string | null;
    per_page?: number;
    sort_dir?: 'asc' | 'desc';
}

class AdminGroupStatusLogClient extends BaseClient {
    getStatusLog(teamId: number, groupId: string, params: GetStatusLogParams) {
        return this.makeCoreApiRequest(`/api/admin/teams/${teamId}/groups/${groupId}/status-log`, 'get', null, params);
    }
}

export default new AdminGroupStatusLogClient();
